import React from 'react';
import { Box, Typography, Grid, Link, Divider, Stack } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import RoomIcon from '@mui/icons-material/Room';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#15A67D',
        color: 'white',
        padding: '2rem 1rem',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        marginTop: 'auto',
        textAlign: 'center',
      }}
    >
      <Grid container spacing={4} justifyContent="space-around">
        {/* Contacto */}
        <Grid item xs={12} md={5}>
          <Box textAlign="left">
            <Typography variant="h6" sx={{ mb: 2 ,  fontWeight: 'bold'}}>
              Contáctanos
            </Typography>
            <Stack spacing={1}>
              <Typography variant="body1" display="flex" alignItems="center">
                <PhoneIcon sx={{ mr: 1 }} /> +591 71964361
              </Typography>
              <Typography variant="body1" display="flex" alignItems="center">
                <EmailIcon sx={{ mr: 1 }} /> radiochukuta@gmail.com
              </Typography>
              <Typography variant="body1" display="flex" alignItems="center">
                <RoomIcon sx={{ mr: 1 }} /> Av. Principal #123, La Paz
              </Typography>
            </Stack>
          </Box>
        </Grid>

        {/* Redes Sociales */}
        <Grid item xs={12} md={5}>
          <Box textAlign="left">
            <Typography variant="h6" sx={{ mb: 2,  fontWeight: 'bold'  }}>
              Síguenos
            </Typography>
            <Stack spacing={1}>
              <Box display="flex" alignItems="center">
                <FacebookIcon sx={{ mr: 1 }} />
                <Link
                  href="https://www.facebook.com/ChukutaDeComunicaciones/"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                  underline="hover"
                >
                  Visítanos en Facebook
                </Link>
              </Box>
              <Box display="flex" alignItems="center">
                <InstagramIcon sx={{ mr: 1 }} />
                <Link
                  href="https://www.instagram.com/chukuta_comunicaciones/"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                  underline="hover"
                >
                  Visítanos en Instagram
                </Link>
              </Box>
                <Box display="flex" alignItems="center">
                    <WhatsAppIcon sx={{ mr: 1 }} />
                    <Link
                        href="https://api.whatsapp.com/send?phone=59169750095&text=Me%20gustaria%20enviar%20un%20saludo%20por%20la%20radio" 
                        target="_blank"
                        rel="noopener noreferrer"
                        color="inherit"
                        underline="hover"
                    >
                        Háblanos en WhatsApp
                    </Link>
                </Box>
            </Stack>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ backgroundColor: 'white', margin: '2rem 0 1rem' }} />

      <Typography variant="body2">
        © 2025 Radio Chukuta Comunicaciones. Todos los derechos reservados. Powered by Mrx Solutions
      </Typography>
    </Box>
  );
};

export default Footer;
